/* eslint-disable no-console */
import React from 'react';
// import PropTypes from 'prop-types';
import { datasetTypeLabels, datasetTypes } from '@/constants';
import * as stringUtils from '@/utils/string-utils';
import { KPIItem } from './kpi-item';
import { Wrapper } from './kpi-styles';

/** Test note
 * This component displays a summary of Key Performance Indicators for a given dataset in
 * a header format
 */
export function KPIRibbon({ currentTab, setCurrentTab, kpiData }) {
  return (
    <Wrapper>
      <KPIItem
        type={datasetTypes.CURRENT_STR_PROPERTIES}
        label={datasetTypeLabels[datasetTypes.CURRENT_STR_PROPERTIES]}
        activeTab={currentTab}
        trend={kpiData.currentStrProperties.trend}
        value={stringUtils.numberWithCommas(kpiData.currentStrProperties.value)}
        onClick={() => setCurrentTab(datasetTypes.CURRENT_STR_PROPERTIES)}
      />
      <KPIItem
        type={datasetTypes.OCCUPANCY}
        label={datasetTypeLabels[datasetTypes.OCCUPANCY]}
        activeTab={currentTab}
        trend={kpiData.occupancy.trend}
        value={stringUtils.numberToPercent(kpiData.occupancy.value)}
        onClick={() => setCurrentTab(datasetTypes.OCCUPANCY)}
      />
      <KPIItem
        type={datasetTypes.REVENUE}
        label={datasetTypeLabels[datasetTypes.REVENUE]}
        activeTab={currentTab}
        trend={kpiData.revenue.trend}
        value={stringUtils.numberWithCommas(kpiData.revenue.value)}
        onClick={() => setCurrentTab(datasetTypes.REVENUE)}
      />
    </Wrapper>
  );
}
